import "./appMenu.scss";

import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { configure, GlobalHotKeys } from "react-hotkeys";

import { keyStringToHotKey } from "../../features/appMenu/constants";

const ignorableTags = ["input", "select", "textarea"];
const ignorableShortcuts = ["ctrl+x", "ctrl+c", "ctrl+v", "del", "shift+del", "backspace", "shift+backspace"];

// By default, react-hotkeys blocks all events when an editable field has focus.
// But we really only want to block specific combinations, so I turn that behaviour off here
// and control for it in the handler instead.
configure({
  ignoreEventsCondition: () => false
});

const isEditableTarget = event => {
  const target = event.target;
  if (target && target.tagName) {
    const tagName = target.tagName.toLowerCase();
    return _.includes(ignorableTags, tagName) || target.isContentEditable;
  } else {
    return false;
  }
};

const getHandlerForItem = (item, onItemClick) => event => {
  const blocked = isEditableTarget(event) && ignorableShortcuts.includes(item.shortcut.toLowerCase());
  if (!item.disabled && !blocked) {
    onItemClick(item.messageType, item.value);
  }
  if (!blocked) {
    event.preventDefault();
  }
};

const getShortcutValue = keysStr => {
  return (
    keysStr
      .split("+")
      .map(k => {
        const lowerKey = k.toLowerCase();
        return keyStringToHotKey[lowerKey] || lowerKey;
      })
      // The array style causes pressing modifier key
      // will opening a new tab in Mac browser
      .join("+")
  );
};

const accumulateKeysAndHandlers = (menuItems, keyMap, handlers, onItemClick) => {
  menuItems.forEach(item => {
    if (item.shortcut) {
      keyMap[item.label] = getShortcutValue(item.shortcut);
      handlers[item.label] = getHandlerForItem(item, onItemClick);
    }
    if (item.children.size > 0) {
      accumulateKeysAndHandlers(item.children, keyMap, handlers, onItemClick);
    }
  });
};

const getKeysAndHandlers = (menuItems, onItemClick) => {
  let keyMap = {};
  let handlers = {};
  accumulateKeysAndHandlers(menuItems, keyMap, handlers, onItemClick);
  return {
    keyMap,
    handlers
  };
};

const AppMenuHotkeys = props => {
  const { keyMap, handlers } = getKeysAndHandlers(props.menuItems, props.onItemClick);
  if (_.size(keyMap)) {
    return <GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges={true} />;
  }
  return null;
};

AppMenuHotkeys.propTypes = {
  menuItems: PropTypes.object.isRequired,
  onItemClick: PropTypes.func
};

export default AppMenuHotkeys;
